import {
    createContext,
    useContext,
    useState,
    type ReactNode,
} from 'react';

interface LayoutContextType {
    isFullWidth: boolean;
    toggleWidth: () => void;
}

const LayoutContext = createContext<LayoutContextType | null>(null);

interface LayoutProviderProps {
    children: ReactNode;
}

function getStoredWidthPreference(): boolean {
    if (typeof window === 'undefined') return false;
    const stored = localStorage.getItem('layoutFullWidth');
    return stored === 'true';
}

export function LayoutProvider({ children }: LayoutProviderProps) {
    const [isFullWidth, setIsFullWidth] = useState<boolean>(
        getStoredWidthPreference,
    );

    const toggleWidth = () => {
        setIsFullWidth((prev) => {
            const newValue = !prev;
            localStorage.setItem('layoutFullWidth', String(newValue));
            return newValue;
        });
    };

    return (
        <LayoutContext.Provider value={{ isFullWidth, toggleWidth }}>
            {children}
        </LayoutContext.Provider>
    );
}

export function useLayout(): LayoutContextType {
    const context = useContext(LayoutContext);
    if (!context) {
        throw new Error('useLayout must be used within a LayoutProvider');
    }
    return context;
}
